export default {
  // 礼品类型：1=实物礼品，2=虚拟礼品
  giftType: {
    1: '实物礼品',
    2: '虚拟礼品',
  },
  // 规格类型：1=单规格，2=多规格
  specType: {
    1: '单规格',
    2: '多规格',
  },
  // 上下架状态：0=下架，1=上架
  publishStatus: {
    0: '已下架',
    1: '已上架',
  },
  // 订单状态：0=待处理，1=已兑换，2=已发货，3=已完成，4=已取消，5=失败
  orderStatus: {
    0: '待处理',
    1: '已兑换',
    2: '已发货',
    3: '已完成',
    4: '已取消',
    5: '失败',
  },
  // 发货状态：1=待发货，2=已发货，3=已完成
  shippingStatus: {
    1: '待发货',
    2: '已发货',
    3: '已完成',
  },
  // 账号状态：0=禁用，1=启用
  accountStatus: {
    0: '已禁用',
    1: '进行中',
  },
  // 账号类型：1=总账号，2=子账号
  accountType: {
    1: '总账号',
    2: '子账号',
  },
  // 加密协议
  encryption: {
    ssl: 'SSL',
    tls: 'TLS',
    none: 'None',
  },
  // 素材类型
  materialType: {
    image: '图片',
    video: '视频',
  },
  // 扫码次数
  scanCount: {
    first: '首次',
    repeated: '重复扫码',
  },
  // 默认模板开关
  isDefault: {
    on: '开启',
    off: '关闭',
  },
};
